import { createContext, useContext } from 'react';

const OutletContext = createContext<React.PropsWithChildren>({});

export const OutletProvider = OutletContext.Provider;

export const Outlet: React.FC = () => {
  const { children } = useContext(OutletContext);

  return children;
};
